import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteSpinRate,
	fetchSpinRate,
	resetDeleteStatusSpinRate,
	updateSpinRate,
} from "../../../actions/spinTheWheelRate";

import "../Question.scss";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import SpinRateForm from "../../Forms/SpinTheWheelRate";
import { DateTimeFormat } from "../../../helpers/utils";

const SpinRatePage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [spinRateId, setSpinRateId] = useState(null);
	const { status, spinRate } = useSelector((state) => state.fetchSpinRate);
	const { status: updateStatus } = useSelector((state) => state.updateSpinRate);
	const { spinRateDeleted } = useSelector((state) => state.deleteSpinRate);
	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		showModal();
		setSpinRateId(spinRate.id);
		form.setFieldsValue({
			...spinRate,
		});
	};

	const handleDelete = () => {
		dispatch(deleteSpinRate(spinRateId));
	};

	const handleSubmitForm = (values) => {
		const newValues = values;
		if (spinRateId) {
			dispatch(updateSpinRate(spinRateId, newValues));
		}
		handleOk();
	};

	useEffect(() => {
		if (id) {
			dispatch(fetchSpinRate(id));
		}
	}, [id]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchSpinRate(id));
	}, [updateStatus]);

	useEffect(() => {
		if (spinRateDeleted) {
			history.push("/spin-the-wheel/rates");
			dispatch(resetDeleteStatusSpinRate());
		}
	}, [spinRateDeleted]);

	useEffect(() => {
		if (spinRate && spinRate.id === Number(id)) {
			setSpinRateId(spinRate.id);
		} else {
			setSpinRateId();
		}
	}, [spinRate]);
	return (
		<div id="question-container">
			<div className="page-header">
				<h2 className="page-header-title">Rate Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/spin-the-wheel/rates">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Game</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinRate.game.name}
										</div>
									</div>
									<div className="details-item">
										<label>Win Chance</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinRate.win_chance}
										</div>
									</div>
									<div className="details-item">
										<label>Estimate Spin Chance</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{spinRate.estimate_spin_chance}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{DateTimeFormat(spinRate.updated_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="spin-form-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<SpinRateForm
					form={form}
					spinRateId={spinRateId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default SpinRatePage;
